import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { usePageTitle } from '@shared/lib/usePageTitle'
import { Spinner } from '@shared/ui/Spinner'

export function BlankLayout() {
  usePageTitle()
  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  )
}
